import type React from 'react';
import { type FC, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { ConfigProvider } from 'antd';
import type { ThemeConfig } from 'antd/lib';
import { THEME } from '@enmon/commons';
import enUS from 'antd/lib/locale/en_US';

interface AppAntConfigProviderProps {
  children: React.ReactNode;
}

export const AppAntConfigProvider: FC<AppAntConfigProviderProps> = ({ children }) => {
  const theme = useTheme();

  const PRIMARY_THEME_TOKEN = {
    borderRadius: 2,
    // Font properties
    fontFamily: THEME.typography.fontFamily.poppins,
    fontWeightStrong: 500,
    // Colors
    colorPrimary: theme.color.theme.primary,
    colorLink: theme.color.theme.primary,
    // Focus state outline
    lineWidthFocus: 0,
  } satisfies ThemeConfig['token'];

  const themeValue = useMemo(
    () => ({
      token: PRIMARY_THEME_TOKEN,
      hashed: false,
      components: {
        Select: {
          optionActiveBg: theme.color.semantic.primary.background.hoverWeak,
        },
        Tag: {
          borderRadius: 4,
        },
      },
    }),
    [PRIMARY_THEME_TOKEN, theme],
  );

  return (
    <ConfigProvider locale={enUS} theme={themeValue}>
      {children}
    </ConfigProvider>
  );
};
